var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1853_4350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5574 9.24144C16.0212 9.24144 15.5861 9.67701 15.5861 10.2137V16.0745C15.5861 17.166 14.6989 18.0553 13.607 18.0553H3.92177C2.83124 18.0553 1.94275 17.1673 1.94275 16.0745V6.38041C1.94275 5.28889 2.82994 4.39959 3.92177 4.39959H9.38609C9.92229 4.39959 10.3575 3.96402 10.3575 3.42734C10.3575 2.89065 9.92229 2.45508 9.38609 2.45508H3.92177C1.75884 2.45508 0 4.21681 0 6.38041V16.0745C0 18.2394 1.75884 19.9998 3.92177 19.9998H13.607C15.77 19.9998 17.5288 18.2394 17.5288 16.0745V10.2137C17.5288 9.67701 17.0936 9.24144 16.5574 9.24144Z",
    fill: "#E75074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 0.970962V0H13.1845C12.6483 0 12.2131 0.435572 12.2131 0.972258C12.2131 1.50894 12.6483 1.94452 13.1845 1.94452H16.6827L6.38227 12.2543C6.00279 12.6342 6.00279 13.2499 6.38227 13.6298C6.57136 13.819 6.82004 13.915 7.06871 13.915C7.31738 13.915 7.56605 13.8203 7.75515 13.6298L18.0569 3.31994V6.82136C18.0569 7.35805 18.4921 7.79362 19.0283 7.79362C19.5645 7.79362 19.9997 7.35805 19.9997 6.82136V0.973555V0.970962Z",
    fill: "#E75074"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1853_4350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bf0c311b41f3763de08ddb686d1c0c11.svg";
export { ForwardRef as ReactComponent };